import { FbPixelDataShape, FbPixelTrackOptionsShape } from '.';

type FbqShape = (
    _arg0?: string,
    _arg1?: string,
    _arg2?: boolean | string | FbPixelDataShape,
    _arg3?: string | FbPixelDataShape | FbPixelTrackOptionsShape,
) => void;

/**
 * Declaring gloval window.fbq function
 * is set in index.html when initializing the pixel
 */
declare global {
    interface Window {
        fbq?: FbqShape;
    }
}

/**
 * Gets facebook function instance from window
 */
const getFb = (): null | FbqShape => {
    const fbq = window.fbq;
    if (!fbq) {
        console.error(
            'Pixel not initialized before using call ReactPixel.init with required params',
        );
        return null;
    }
    return fbq;
};

const FacebookPixel = {
    pageView(): void {
        const fb = getFb();
        if (fb) {
            fb('track', 'PageView');
        }
    },

    track(
        event: string,
        data?: FbPixelDataShape,
        options?: FbPixelTrackOptionsShape,
    ): void {
        const fb = getFb();
        if (fb) {
            fb('track', event, data, options);
        }
    },

    /**
     * Track custom events (non-standard Facebook events)
     */
    trackCustom(event: string, data?: FbPixelDataShape): void {
        const fb = getFb();
        if (fb) {
            fb('trackCustom', event, data);
        }
    },
};

export default FacebookPixel;
